import { Form, Input, Select } from 'antd'
import { useState } from 'react'
import { ButtonCommon } from 'src/common'
import { useAppDispatch } from 'src/hooks'
import { onCreateOrderManual } from 'src/redux/order/order.action'
import { showMessageError, showMessageSuccess } from 'src/utils/function.utils'
import './FormAddOrder.scss'

const DEFAULT_METHOD = 'manual'

const FormAddOrder = () => {
	const dispatch = useAppDispatch()
	const [form] = Form.useForm()

	const [isSubmitLoading, setIsSubmitLoading] = useState()

	const handleSubmit = async () => {
		const values = await form.validateFields()
		setIsSubmitLoading(true)
		dispatch(onCreateOrderManual(values, handleSubmitCb))
	}

	const handleSubmitCb = (isSuccess, rs) => {
		setIsSubmitLoading(false)
		if (isSuccess) {
			showMessageSuccess()
			form.resetFields()
		} else {
			showMessageError(rs)
		}
	}
	const optionOrders = [
		{
			value: 'PRO_1_MONTHS',
		},
		{
			value: 'PRO_3_MONTHS',
		},
		{
			value: 'PRO_6_MONTHS',
		},
		{
			value: 'PRO',
		},
		{
			value: 'PRO_FOREVER',
		},
	]

	return (
		<Form form={form} initialValues={{ method: DEFAULT_METHOD }}>
			<Form.Item
				label="Email or AuthName"
				name="IdentifyKey"
				type="string"
				rules={[
					{
						required: true,
						message: 'Please enter email or authName!',
					},
				]}
			>
				<Input placeholder={`Enter email or authName`} />
			</Form.Item>

			<Form.Item label="Order type" name="SubscriptionCode">
				<Select
					options={optionOrders}
					placeholder="Select type of order"
					showSearch
					optionFilterProp="children"
					filterOption={(input, options) =>
						(options.label ?? '')
							.toLowerCase()
							.includes(input.toLowerCase())
					}
				></Select>
			</Form.Item>
			<Form.Item label="Method" name="method">
				<Input placeholder={`Manual/ MoMo/ ... (for tracking data)`} />
				{/* <Select
					options={optionMethods}
					placeholder="Select type of order"
					showSearch
					optionFilterProp="children"
					filterOption={(input, options) =>
						(options.label ?? '')
							.toLowerCase()
							.includes(input.toLowerCase())
					}
				></Select> */}
			</Form.Item>
			<div className="u-row-right">
				<ButtonCommon
					onClick={handleSubmit}
					type="primary"
					loading={isSubmitLoading}
				>
					Add order
				</ButtonCommon>
			</div>
		</Form>
	)
}

export default FormAddOrder

// FormAddOrder
